class MainNavigation {
	constructor() {
		this.navElement = document.querySelector(".main-navigation");

		if (this.navElement) {
			//this.regionDropdown = this.navElement.querySelector('.js-region-dropdown');
			this.regionDropdown = this.navElement.querySelector(".region-dropdown a");
			this.init();
		}
	}

	init() {
		// Add proper event listener scoped to this navigation component
		if (this.regionDropdown) {
			//this.regionDropdown.addEventListener('change', (e) => this.updateRegionQueryString(e.target.value));
			$('.region-dropdown a').on("click", function (event) {
				window.location.hash = "";
				const region = event.target.dataset.region;
				const url = new URL(window.location.href);
				if (region && region !== "") {
					url.searchParams.set("region", region);
				} else {
					url.searchParams.delete("region");
				}
				window.location.href = url.toString();
			});
		}
	}

	updateRegionQueryString(selectedRegion) {
		// Get current URL
		const url = new URL(window.location.href);

		// Update or add the region parameter (preserve the brand parameter)
		if (selectedRegion && selectedRegion !== "") {
			url.searchParams.set("region", selectedRegion);
		} else {
			url.searchParams.delete("region");
		}

		// Navigate to the new URL (brand and other parameters are preserved)
		window.location.href = url.toString();
	}
}
$(window).on("load resize", function () {
	//region-dropdown
	if ($(window).width() <= 1080) {
		$(".region-dropdown").removeClass("dropdown-menu");
	} else {
		$(".region-dropdown").addClass("dropdown-menu");
	}
});

$(document).on('click', 'a.nav-link[href^="#"]', function (e) {
	// Prevent the default browser behavior of immediately jumping to the anchor
	e.preventDefault();
	console.log('e');
	// Get the href attribute, which contains the ID (e.g., "#mySection")
	var targetId = $(this).attr('href');

	// Select the target element using its ID
	var $targetElement = $(targetId);

	// Check if the target element exists on the page
	if ($targetElement.length === 0) {
		return; // Exit if the target element is not found
	}

	// Calculate the top position of the target element relative to the document
	if ($('.hero-brand-region').length) {
		var targetPosition = $targetElement.offset().top - 100;
	} else {
		var targetPosition = $targetElement.offset().top - 10;
	}
	// Animate the scrolling of the html and body elements
	$('html, body').animate({
		scrollTop: targetPosition
	}, 500); // 500 milliseconds for the animation duration (adjust as needed)
});